import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/types';
import { centsToUnits } from '@systemeio/util';
import RazorpayUpgradePlanModal from 'modules/profile/user-plan/components/price-plan-columns/components/razorpay-upgrade-plan-modal';
import StripeUpgradePlanModal from 'modules/profile/user-plan/components/price-plan-columns/components/stripe-upgrade-plan-modal';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UserPlanInterface, UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { Button, Tooltip } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
import { twMerge } from 'tailwind-merge';
import { getPricePlanParams } from '../utils/get-price-plan-params';
export interface HeaderBlockProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  active?: boolean;
  paymentMethod?: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable?: boolean;
}
const HeaderBlock = t0 => {
  const $ = _c(41);
  const {
    pricePlan,
    billingPeriod,
    active: t1,
    paymentMethod,
    isPlanUpgradeAvailable
  } = t0;
  const active = t1 === undefined ? false : t1;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== active || $[1] !== billingPeriod || $[2] !== isPlanUpgradeAvailable || $[3] !== paymentMethod || $[4] !== pricePlan || $[5] !== t || $[6] !== user?.dashboardLocale) {
    const {
      cost,
      paymentPageUrl,
      periodLabel
    } = getPricePlanParams(pricePlan);
    const isPriceInvisible = !pricePlan.price;
    let costTitleShort = "";
    let costTitle = "";
    if (pricePlan.price) {
      costTitleShort = currencyFormat(centsToUnits(cost), pricePlan.price.currency || CurrencyEnum.EURO, user?.dashboardLocale, true);
      costTitle = currencyFormat(centsToUnits(cost), pricePlan.price.currency || CurrencyEnum.EURO, user?.dashboardLocale);
    }
    t6 = `headCell-${pricePlan.id}`;
    const t8 = active ? "text-text-link" : "text-text-primary";
    if ($[13] !== t8) {
      t7 = twMerge("h-[150px] text-start font-bold", t8, "mb-6 min-w-[100px]");
      $[13] = t8;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const t9 = !active && "border-border-200 rounded-lg border-solid";
    if ($[15] !== t9) {
      t2 = twMerge("desktop:px-4 flex flex-col gap-2 border border-transparent px-2 py-2", t9);
      $[15] = t9;
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    let t10;
    if ($[17] !== active) {
      t10 = active ? {
        "data-test": "current-plan"
      } : {};
      $[17] = active;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    let t11;
    if ($[19] !== pricePlan.title || $[20] !== t10) {
      t11 = <span className="truncate" {...t10}>{pricePlan.title}</span>;
      $[19] = pricePlan.title;
      $[20] = t10;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    if ($[22] !== pricePlan.title || $[23] !== t11) {
      t3 = <div className="truncate text-xl font-medium"><Tooltip mode="overflow" label={pricePlan.title}>{t11}</Tooltip></div>;
      $[22] = pricePlan.title;
      $[23] = t11;
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    const t12 = isPriceInvisible && "invisible";
    let t13;
    if ($[25] !== t12) {
      t13 = twMerge("truncate", t12);
      $[25] = t12;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    t4 = <div className={t13}><span className="desktop:text-3xl text-xl">{costTitleShort}</span><span className="text-base font-normal">/{t(periodLabel).toLowerCase()}</span></div>;
    t5 = active ? <Button title={t("dashboard.settings.user_plan.current_plan_title")} data-test-id={`button-plan-${pricePlan.title.toLowerCase()}-current`} variant="primary" size="sm" aria-disabled={true} render={<LinkWithoutPrefetch href={paymentPageUrl} />}><span className="truncate">{t("dashboard.settings.user_plan.current_plan_title")}</span></Button> : pricePlan.oneClickAvailable ? <StripeUpgradePlanModal pricePlan={pricePlan} billingPeriod={billingPeriod} paymentPageUrl={paymentPageUrl} cost={costTitle + `/${t(periodLabel).toLowerCase()}`} paymentMethod={paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable} /> : pricePlan.switchAvailable ? <RazorpayUpgradePlanModal pricePlan={pricePlan} billingPeriod={billingPeriod} paymentPageUrl={paymentPageUrl} cost={costTitle + `/${t(periodLabel).toLowerCase()}`} isPlanUpgradeAvailable={isPlanUpgradeAvailable} /> : <div className="flex flex-col gap-2"><Button title={t("dashboard.settings.user_plan.upgrade_plan_title")} data-test-id={`link-plan-${pricePlan.title.toLowerCase()}-upgrade`} variant="primary" size="sm" disabled={!paymentPageUrl || !isPlanUpgradeAvailable} render={!(!paymentPageUrl || !isPlanUpgradeAvailable) ? <LinkWithoutPrefetch href={paymentPageUrl} /> : undefined}><span className="truncate">{t("dashboard.settings.user_plan.upgrade_plan_title")}</span></Button></div>;
    $[0] = active;
    $[1] = billingPeriod;
    $[2] = isPlanUpgradeAvailable;
    $[3] = paymentMethod;
    $[4] = pricePlan;
    $[5] = t;
    $[6] = user?.dashboardLocale;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[27] !== active || $[28] !== t || $[29] !== user?.accessRestricted) {
    t8 = active && user?.accessRestricted && <div className="text-text-error text-center text-base font-normal">{t("dashboard.settings.user_plan.restricted")}</div>;
    $[27] = active;
    $[28] = t;
    $[29] = user?.accessRestricted;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t8) {
    t9 = <div className={t2}>{t3}{t4}{t5}{t8}</div>;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t6 || $[38] !== t7 || $[39] !== t9) {
    t10 = <div key={t6} className={t7}>{t9}</div>;
    $[37] = t6;
    $[38] = t7;
    $[39] = t9;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  return t10;
};
export default HeaderBlock;